export default {
    heading: 'Добавить скидку',
    discount: 'Скидки',
    discount_title: 'Скидка',
    title: {
        label: 'Название скидки',
        placeholder: 'Введите название скидки',
    },
    date_from: {
        label: 'От даты',
        placeholder: 'Введите от даты',
    },
    date_to: {
        label: 'До даты',
        placeholder: 'Введите до даты',
    },
    percentage: {
        label: 'Процент',
        placeholder: 'Введите процент',
    },
    price: {
        label: 'Новая цена',
        placeholder: 'Введите новую цену',
    },
    offer: {
        label: 'Предложение',
        placeholder: 'Выберите предложение',
    },
    category: {
        label: 'Категории',
        placeholder: 'Выберите категории',
    },
    table: {
        offer: 'Предложение',
        category: 'Категория',
        title: 'Название',
        date_from: 'От даты',
        date_to: 'До даты',
        percentage: 'Процент',
        actions: 'Действия',
    },
    discount_info: 'Скидка будет применяться ко всем бронированиям, сделанным в указанном временном диапазоне.',
    delete_discount: 'Вы уверены, что хотите удалить скидку?',
    warning: 'На данный момент нет скидок!',
}
